import React from 'react';
import { fontWeightBold } from '../../../../ui-components/design-tokens';
import { SIZE } from '../../../../ui-components/typography/PlayText/PlayText';
import {
    StyledEditorialMessageLink,
    StyledEditorialMessageText,
    StyledEditorialMessage,
} from './EditorialMessage.styles';

const Message = ({ message, linkText, link, boldText = false, urgent = false }) =>
    message || link ? (
        <StyledEditorialMessage urgent={urgent}>
            {message && (
                <StyledEditorialMessageText size={SIZE.LARGE} weight={boldText ? fontWeightBold : undefined}>
                    {message}
                </StyledEditorialMessageText>
            )}
            {link && linkText && (
                <StyledEditorialMessageLink href={link} size={SIZE.LARGE}>
                    <span>{linkText}</span>
                </StyledEditorialMessageLink>
            )}
        </StyledEditorialMessage>
    ) : null;

export default Message;
